import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { toast } from 'react-toastify';
import copy from 'clipboard-copy';

import { LoaderObjeto } from '~/components/Loaders';
import * as ActionsLinks from '~/store/modules/client/maquinaVirtual/actions';

export function ModalConfirmacaoSimples(props) {
	const { isOpen, toggle } = props;
	const dispatch = useDispatch();
	const { linkSimples } = useSelector((state) => state.clientMaquinaVirtual);

	function handlerCopy(item) {
		copy(item.checkout_link);
		toast.success('Link copiado');
	}
	const handleClose = () => dispatch(ActionsLinks.clearLink());

	return (
		<Modal isOpen={isOpen} toggle={toggle} onClosed={handleClose} size="lg">
			<ModalHeader>
				{linkSimples.error === null && !linkSimples.loading && (
					<div className="d-flex justify-content-between">
						<span>Seu link foi gerado com sucesso</span>
					</div>
				)}
			</ModalHeader>
			<ModalBody>
				<LoaderObjeto
					loading={linkSimples.loading}
					obj={linkSimples.dados}
					error={linkSimples.error}>
					<div style={{ wordWrap: 'break-word' }}>
						<a href={linkSimples.dados.checkout_link}>
							{linkSimples.dados.checkout_link}
						</a>
					</div>
					<div className="d-flex justify-content-center">
						<Button onClick={toggle} color="secondary">
							Fechar
						</Button>
						<Button
							color="primary"
							onClick={() => handlerCopy(linkSimples.dados)}>
							Copiar link
						</Button>
					</div>
				</LoaderObjeto>
			</ModalBody>
			<ModalFooter />
		</Modal>
	);
}
